module.exports = __webpack_public_path__ + "static/media/lightbulb-infographic.be8528cf.png";